import { B2BCourseGrantPayload } from "../../ProductService/BonificoOrder/BonificoOrderDTO.ts";

export type B2BCourseGrantDraft = {
  email: string;
  firstName: string;
  lastName: string;
  productId: string;
};

export type B2BCourseGrantDraftErrors = Partial<
  Record<keyof B2BCourseGrantDraft, string>
>;

export const EMPTY_COURSE_GRANT_DRAFT: B2BCourseGrantDraft = {
  email: "",
  firstName: "",
  lastName: "",
  productId: "",
};

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateCourseGrantDrafts(
  drafts: B2BCourseGrantDraft[],
): B2BCourseGrantDraftErrors[] {
  return drafts.map((draft) => ({
    ...(!EMAIL_REGEX.test(draft.email.trim()) && {
      email: "Email non valida",
    }),
    ...(!draft.firstName.trim() && { firstName: "Obbligatorio" }),
    ...(!draft.lastName.trim() && { lastName: "Obbligatorio" }),
    ...(!draft.productId && { productId: "Scegli il prodotto" }),
  }));
}

export function hasCourseGrantDraftErrors(
  errors: B2BCourseGrantDraftErrors[],
): boolean {
  return errors.some((rowErrors) => Object.keys(rowErrors).length > 0);
}

export function toCourseGrantPayloads(
  drafts: B2BCourseGrantDraft[],
): B2BCourseGrantPayload[] {
  return drafts.map((draft) => ({
    beneficiary: {
      email: draft.email.trim(),
      firstName: draft.firstName.trim(),
      lastName: draft.lastName.trim(),
    },
    productId: draft.productId,
  }));
}
